import { type Question } from '~/hooks/useSurveyQuery'
import { type DisplayRowItem, pathAssume, QuestionOp } from '~/utils'

import { type DisplayRowId, getAnswerOptionRowId } from '../utils'

import { useDisplayRowItems } from './useDisplayRowItems'
import { useMatrixAnswersData } from './useMatrixAnswersData'

export const useMatrixDisplayRowItems = (
  question: Question,
): DisplayRowItem<DisplayRowId>[] => {
  const answersData = useMatrixAnswersData(question, 'all')

  return useDisplayRowItems('matrix', [answersData], {
    getLabel: () => QuestionOp.toText(question),
    getRowId: (answerData) =>
      getAnswerOptionRowId(question, answerData.answerOption),
    getSubLabel: pathAssume('answerOption.text'),
  })
}
